<template>


    <div class="layout">
        <div class="cabinet-page_bg"></div>

        <Header/>

        <div class="main-content-wrapper">
            <div class="main-content">
                <h1 v-html="$ml.with('VueJS').get('termsOfUse')"></h1>
                <div v-html="$ml.with('VueJS').get('termsOfUseText')"></div>
            </div>
        </div>


        <Contacts/>

        <Footer/>
        <AuthorizationWindow/>
    </div>

</template>



<script>

    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Contacts from '@/components/Contacts';
    import AuthorizationWindow from "../components/windows/AuthorizationWindow";




    export default {
        name: 'TermsOfUse',

        beforeCreate() {
            $('body').attr('class', 'agreement-page index-layout');
        },


        metaInfo: {
            title: 'Пользовательское соглашение'
        },

        components: {
            AuthorizationWindow,
            Header, Footer, Contacts
        }
    }
</script>
